import StageListPage from './list'
export default StageListPage
